import axios from 'axios';

export default {
    getMine(context, ids) {
        var options = {
            method: 'GET',
            url: window.apiUrl + '/submissions?ids=' + ids,
            params: {
                // cache: 'submissions'
            },
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },

}


// WEBPACK FOOTER //
// ./src/services/submissions/index.js